import { render } from "./region.vue?vue&type=template&id=724c47eb&scoped=true"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"

import "./region.vue?vue&type=style&index=0&id=724c47eb&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724c47eb"],['__file',"vue/js/components/shared/users/region.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "724c47eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('724c47eb', __exports__)) {
    console.log('reload')
    api.reload('724c47eb', __exports__)
  }
  
  module.hot.accept("./region.vue?vue&type=template&id=724c47eb&scoped=true", () => {
    console.log('re-render')
    api.rerender('724c47eb', render)
  })

}


export default __exports__